import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AbilitiesService from 'ember-can/services/abilities';
import type StateService from 'garaje/services/state';

interface ManageMenuArgs {
  trackClickEvent: (trackingString: string) => void;
}

export default class ManageMenuComponent extends Component<ManageMenuArgs> {
  @service declare state: StateService;
  @service declare abilities: AbilitiesService;

  get manageLocationSettingsRegex(): RegExp {
    return /^manage\.location-settings/;
  }

  get manageRoute(): string {
    if (this.abilities.can('visit local admins in manage-settings')) {
      return 'manage.admin-users';
    }

    if (this.abilities.can('visit local custom roles in manage-settings')) {
      return 'manage.roles';
    }

    if (this.abilities.can('update local settings in manage-settings')) {
      return 'manage.location-settings';
    }

    if (this.abilities.can('visit local event log in manage-settings')) {
      return 'manage.event-log';
    }

    return 'unauthorized';
  }
}
